import { z } from 'zod';
export const createRecordingRoomSchema = z.object({
    name: z.string().min(1).max(255),
    projectId: z.string().uuid().optional(),
});
export const updateRecordingRoomSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    status: z.enum(['waiting', 'recording', 'stopped', 'error']).optional(),
});
export const VIDEO_LAYOUT_TYPES = [
    'fullscreen',
    'pip',
    'side-by-side',
    'grid',
];
export const createVideoLayoutSchema = z.object({
    projectId: z.string().uuid(),
    name: z.string().min(1).max(200),
    type: z.enum(VIDEO_LAYOUT_TYPES).optional(),
    config: z.record(z.unknown()).optional(),
});
export const updateVideoLayoutSchema = createVideoLayoutSchema.partial();
export const VIDEO_TRANSITION_TYPES = [
    'fade',
    'cut',
    'dissolve',
    'wipe-left',
    'wipe-right',
    'slide-up',
];
export const createVideoTransitionSchema = z.object({
    projectId: z.string().uuid(),
    fromRegionId: z.string().uuid(),
    toRegionId: z.string().uuid(),
    type: z.enum(VIDEO_TRANSITION_TYPES),
    durationMs: z.number().int().min(0).max(10_000),
});
export const createTextOverlaySchema = z.object({
    projectId: z.string().uuid(),
    startMs: z.number().int().min(0),
    endMs: z.number().int().min(0),
    text: z.string().min(1).max(2000),
    style: z.record(z.unknown()).optional(),
});
export const updateTextOverlaySchema = createTextOverlaySchema.partial();
//# sourceMappingURL=video.schemas.js.map